<template>
  <div class="page-footer">
    <div class="page-footer-service" v-if="showHotline">
      如有疑问，请联系相关业务员或客服：400-820-2288
    </div>
    <div class="page-footer-logo">
      <img src="@/assets/img-cathay-footer.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',

  props: {
    showHotline: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="less">
.page-footer {
  padding: 24px 8px;
  text-align: center;

  &-service {
    color: #9b9b9b;
    font-size: 12px;
    text-align: center;
    margin-bottom: 8px;
  }

  &-logo {
    img {
      width: 150px;
      height: auto;
    }
  }
}
</style>
